import { render, staticRenderFns } from "./FaqTypeForm.vue?vue&type=template&id=444768c8&scoped=true"
import script from "./FaqTypeForm.vue?vue&type=script&lang=js"
export * from "./FaqTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444768c8",
  null
  
)

export default component.exports